
    import {Vue, Component} from 'vue-property-decorator'

    @Component
    export default class NoFound extends Vue{
        mounted(){
            let timer = setTimeout(() => {
                this.$router.back()
            }, 2000)

            this.$once('hook:beforeDestroy', function () {
                clearTimeout(timer)
            })
        }

    }
